import SubscribeViewCollectionsComponent from "./SubscribeViewCollectionsComponent";

export default SubscribeViewCollectionsComponent;